async function bondFixedTermTellerCreate(contracts, contractName, underlying, expiry, amount) {
  const teller = contracts.getContractByName(contractName);
  return await teller.create(underlying, expiry, amount);
}

async function bondFixedTermTellerRedeem(contracts, contractName, tokenId, amount) {
  const teller = contracts.getContractByName(contractName);
  return await teller.redeem(tokenId, amount);
}

async function bondFixedTermTellerBatchRedeem(contracts, contractName, tokenIds, amounts) {
  const teller = contracts.getContractByName(contractName);
  return await teller.batchRedeem(tokenIds, amounts);
}

async function bondFixedTermTellerDeploy(contracts, contractName, underlying, expiry) {
  const teller = contracts.getContractByName(contractName);
  return await teller.deploy(underlying, expiry);
}

async function bondFixedTermTellerGetTokenNameAndSymbol(contracts, contractName, tokenId) {
  const teller = contracts.getContractByName(contractName);
  return await teller.getTokenNameAndSymbol(tokenId);
}

module.exports = {
  bondFixedTermTellerCreate,
  bondFixedTermTellerRedeem,
  bondFixedTermTellerBatchRedeem,
  bondFixedTermTellerDeploy,
  bondFixedTermTellerGetTokenNameAndSymbol,
};
